import axios from 'src/app-axios';
import Constants from 'src/constants';
export const appusers = {
  namespaced: true,
  state: {
    onSiteAppUsersAttendence: [],
    offSiteAppUsersAttendence: [],
    acceptedAppUsersList: [],
    appUserDetails: {},
    appUserCompanies: [],
    pendingAppUsersList: [],
    filterAppUsersList: [],
  },
  getters: {
    getOnSiteAppUsersAttendence (state) {
      return state.onSiteAppUsersAttendence;
    },
    getOffSiteAppUsersAttendence (state) {
      return state.offSiteAppUsersAttendence;
    },
    getAcceptedAppUsersList (state) {
      return state.acceptedAppUsersList;
    },
    getAppUserDetails (state) {
      return state.appUserDetails;
    },
    getAppUserCompanies (state) {
      return state.appUserCompanies;
    },
    getPendingAppUsersList (state) {
      return state.pendingAppUsersList;
    },
    getFilterAppUsersList (state) {
      return state.filterAppUsersList;
    },
  },
  mutations: {
    setOnSiteAppUsersAttendenceList (state, data) {
      state.onSiteAppUsersAttendence = [
        ...state.onSiteAppUsersAttendence,
        ...data,
      ];
    },
    setOffSiteAppUsersAttendenceList (state, data) {
      state.offSiteAppUsersAttendence = [
        ...state.offSiteAppUsersAttendence,
        ...data,
      ];
    },
        setOnSiteAppUsersAttendence (state, data) {
      state.onSiteAppUsersAttendence = data;
    },
    setOffSiteAppUsersAttendence (state, data) {
      state.offSiteAppUsersAttendence = data;
    },
    clearOnSiteAttendence (state) {
      state.onSiteAppUsersAttendence = [];
    },
    clearOffSiteAttendence (state) {
      state.offSiteAppUsersAttendence = [];
    },
    setAcceptedAppUsersList (state, data) {
      state.acceptedAppUsersList = [...state.acceptedAppUsersList, ...data];
    },
    setAppUserDetails (state, data) {
      state.appUserDetails = data;
    },
    clearAcceptedAppUsersData (state) {
      state.acceptedAppUsersList = [];
    },
    setAppUserCompanies (state, data) {
      state.appUserCompanies = data;
    },
    setPendingAppUsersList (state, data) {
      state.pendingAppUsersList = [...state.pendingAppUsersList, ...data];
    },
    clearPendingAppUsersData (state) {
      state.pendingAppUsersList = [];
    },
    setFilterAppUsersList (state, data) {
      state.filterAppUsersList = data;
    },
    clearFilterAppUsersList (state) {
      state.filterAppUsersList = [];
    },
  },
  actions: {
    async fetchOnSiteAppUsersAttendence ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.organizationId}/attendance/${payload.type}`;
      try {
        const attendence = await axios.get(url, payload.params);
        commit('setOnSiteAppUsersAttendenceList', attendence.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the app users onsite attendence list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchOffSiteAppUsersAttendence ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.organizationId}/attendance/${payload.type}`;
      try {
        const attendence = await axios.get(url, payload.params);
        commit('setOffSiteAppUsersAttendenceList', attendence.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the app users attendence list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearOnSiteAppUsersAttendence ({ commit }) {
      commit('clearOnSiteAttendence');
    },
    clearOffSiteAppUsersAttendence ({ commit }) {
      commit('clearOffSiteAttendence');
    },
    async fetchAcceptedAppUsersList ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExternalId}/workers`;
      try {
        const appUsers = await axios.get(url, payload.params);
        commit('setAcceptedAppUsersList', appUsers.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the app users list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchPendingAppUsersList ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExternalId}/workers`;
      try {
        const appUsers = await axios.get(url, payload.params);
        commit('setPendingAppUsersList', appUsers.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the app users list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchFilterAppUsersList ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExternalId}/workers/filters`;
      try {
        const appUsers = await axios.get(url, payload.params);
        commit('setFilterAppUsersList', appUsers.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the app users list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearFilterAppUsersList ({ commit }) {
      commit('clearFilterAppUsersList');
    },
    async fetchAppUserDetails ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/app-users/${payload.id}`;
      try {
        const details = await axios.get(url);
        commit('setAppUserDetails', details.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the app users details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchAppUserCompanies ({ dispatch, commit }, payload) {
      const url = 'api/devices/';
      try {
        const details = await axios.get(url, payload);
        commit('setAppUserCompanies', details.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the app users companies.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearAcceptedAppUsersList ({ commit }) {
      commit('clearAcceptedAppUsersData');
    },
    clearPendingAppUsersList ({ commit }) {
      commit('clearPendingAppUsersData');
    },
    async createAppUser ({ dispatch }, payload) {
      const url = `/api/devices/organizations/${payload.externalId}/app-users`;
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async updatePendingAppUser ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExternalId}/app-users/${payload.appUserExtId}/update`;
      try {
        await axios.put(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async updateAppUserStatus ({ dispatch }, payload) {
      const url = `api/devices/app-users/requests/${payload.appUserOrganizationId}`;
      try {
        await axios.post(url, payload.status);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async updateUserStatus ({ dispatch }, payload) {
      const url = `api/devices/app-users/${payload.id}/status`;
      try {
        await axios.put(url, payload.status);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async updateAppUserPlatform ({ dispatch }, payload) {
      const url = 'api/devices/platforms';
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in updating user platform',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async deleteAppUser ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgExternalId}/app-users/${payload.appUserExtId}`;
      try {
        await axios.delete(url);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: exception.response.data.message,
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
        async refreshAttendance ({ dispatch, commit }, payload) {
      const onSiteUrl = `api/devices/organizations/${payload.organizationId}/attendance/on-site`;
      try {
        const attendence = await axios.get(onSiteUrl, payload.params);
        commit('setOnSiteAppUsersAttendence', attendence.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the app users onsite attendence list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
      const offSiteUrl = `api/devices/organizations/${payload.organizationId}/attendance/off-site`;
       try {
        const attendence = await axios.get(offSiteUrl, payload.params);
        commit('setOffSiteAppUsersAttendence', attendence.data.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the app users offsite attendence list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
  },
};
